<template>
  <div class="section grid-view" style="padding: 10px 20px">
    <div class="main-content">
      <div class="operations" style="margin-bottom: 5px">
        <div class="triggers">
          <div>
            <el-button
              no="new"
              :disabled="!isEdit"
              type="primary"
              @click="showEditDialog(true)"
            >{{ $t('common.btn.new') }}
            </el-button>
            <!-- <el-button
              :disabled="!isEdit"
              type="primary"
              @click="showEditDialog(false)"
            >{{ $t('common.btn.edit') }}</el-button>-->
            <el-button no="delete" :disabled="!isEdit" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
          </div>
        </div>
      </div>
      <div class="grid-wrapper">
        <cargo-ag-grid
          :grid-params.sync="girdParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('queryJob.bookingAgent')">
            <cargo-advance-select
              no="bookingAgentUuid"
              :select-type="selectTypeNames.basic_data_Company"
              :cache="false"
              filterable
              :method-params="{bookingAgent: true}"
              :callback-params="{key:'bookingAgentUuid'}"
              callback-method-type="value"
              :default-value="editDialog.form.bookingAgentUuid||''"
              tag-value="uuid"
              :static-options="filterCompanyList"
              style="width:205px;"
              @parentCallBack="bookingAgentChange"
            />
          </el-form-item>
          <el-form-item v-show="seaCmp&&airCmp" :label="$t('Partners.carrierType')">
            <el-radio-group v-model="editDialog.form.carrierType" no="carrierType" @change="carrierTypeChangeHandler">
              <el-radio no="shippingCompany" :label="0">{{ $t('SeaExport.ShippingCompany') }}</el-radio>
              <el-radio no="airlineCompany" :label="1">{{ $t('SeaExport.AirlineCompany') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('Partners.bookingMethod')">
            <el-select v-model="editDialog.form.bookingMode" no="bookingMode" :placeholder="$t('Message.PleaseSelect')" style="padding-left: 2px;">
              <el-option
                v-for="item in bookingModes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="saveSub">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import initTemplate from '@/utils/vueInitTemplate'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { AutoIncrementNum } from '@/utils/commonUtil'
import { getCompanyListByType } from '@/api/company'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'

export default {
  name: 'CarrierBookingAgentForm',
  components: { cargoAdvanceSelect, cargoCompanySelect },
  props: {
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedRow: null,
      partner: null,
      ...initTemplate.data,
      selectTypeNames: TYPE_NAMES,
      companyList: [],
      companyMap: new Map(),
      filter: {
        carrierUuid: ''
      },
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: p => { this.selectedRow = p.data }
      },
      columnDefs: [
        {
          headerName: '',
          headerCheckboxSelection: true,
          checkboxSelection: true,
          width: 55,
          pinned: 'left',
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('queryJob.bookingAgent'),
          field: 'bookingAgentUuid',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'uuid', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('Partners.carrierType'),
          field: 'carrierType',
          width: 200,
          cellRenderer: params => {
            return params.value === 0 ? this.$t('SeaExport.ShippingCompany') : this.$t('SeaExport.AirlineCompany')
          }
        }, {
          headerName: this.$t('Partners.bookingMethod'),
          field: 'bookingMode',
          width: 200,
          cellRenderer: params => {
            return params.value === 0 ? 'EDI' : (params.value === 1 ? this.$t('Partners.online') : this.$t('Partners.paper'))
          }
        }
      ],
      rowData: [],
      deletedCarrierBookingAgentsKeys: [],
      bookingModes: [],
      seaCmp: false,
      airCmp: false,
      editDialog: {
        visible: false,
        title: '',
        initialForm: {
          uuid: '',
          branchId: '',
          carrierType: 0,
          bookingMode: null,
          carrierUuid: '',
          bookingAgentUuid: ''
        },
        form: {}
      },
      tempCarrierUuid: null,
      autoIncrementNum: new AutoIncrementNum()
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    },
    isEdit() {
      return this.action === 'new' || this.action === 'edit'
    },
    filterCompanyList() {
      if (this.editDialog.form.carrierType === 0) {
        return this.companyList.filter(p => p.seaCmp)
      } else if (this.editDialog.form.carrierType === 1) {
        return this.companyList.filter(p => p.airCmp)
      } else {
        return []
      }
    }
  },
  created() {
    /* 订舱方式 */
    this.bookingModes.push({ label: 'EDI', value: 0 })
    this.bookingModes.push({ label: this.$t('Partners.online'), value: 1 })
    this.bookingModes.push({ label: this.$t('Partners.paper'), value: 2 })
    /* Promise Begin */
    Promise.all([
      getCompanyListByType({ pageNum: 1, pageSize: 1000000, type: 'seaCmp' }),
      getCompanyListByType({ pageNum: 1, pageSize: 1000000, type: 'airCmp' })
    ]).then(results => {
      this.companyList = [...results[0].data.list, ...results[1].data.list]
      for (const item of this.companyList) {
        this.companyMap.set(item.uuid, item.chineseName)
      }
      this.completeInit()
    })
    /* Promise End */
  },
  methods: {
    ...initTemplate.methods,
    onShow(row, isRefresh) {
      this.partner = row
      if (isRefresh) {
        this.filter.carrierUuid = row.uuid
        this.filter.pageNum = 1
        this.editDialog.initialForm.branchId = row.branchId
        this.editDialog.initialForm.carrierUuid = row.uuid
        this.afterInit(() => {
          this.rowData = row.carrierList
          this.rowData.forEach(item => {
            item.seq = this.autoIncrementNum.getNextNum()
          })
        })
        this.deletedCarrierBookingAgentsKeys = []
      }
      this.seaCmp = row.seaCmp
      this.airCmp = row.airCmp
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = JSON.parse(JSON.stringify(this.editDialog.initialForm))
        this.editDialog.form.seq = this.autoIncrementNum.getNextNum()
        if (this.seaCmp) {
          this.editDialog.form.carrierType = 0
        } else if (this.airCmp) {
          this.editDialog.form.carrierType = 1
        }
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        const cell = this.gridApi.getFocusedCell()
        const row = cell ? this.rowData[cell.rowIndex] : null
        if (!row) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...row }
        this.editDialog.title = this.$t('common.btn.edit')
      }
      this.editDialog.visible = true
    },
    bookingAgentChange(item) {
      this.editDialog.form.bookingAgentUuid = item.value
    },
    getSubmitData() {
      return {
        carrierBookingAgents: this.rowData,
        deletedCarrierBookingAgentsKeys: this.deletedCarrierBookingAgentsKeys
      }
    },
    async saveSub() {
      const self = this
      const form = self.editDialog.form
      if (!form.bookingAgentUuid) {
        this.$message.warning(this.$t('Partners.bookingAgentNotSelected'))
        return
      }
      const checkedBookingAgent = await this.checkedBookingAgent()
      if (!checkedBookingAgent) {
        this.$message.warning(this.$t('Partners.bookingAgentAlreadyExists'))
        return
      }
      if (form.bookingMode === null || form.bookingMode === undefined) {
        this.$message.warning(this.$t('Partners.bookingMethodNotSelected'))
        return
      }
      this.rowData.push(form)
      self.editDialog.visible = false
      this.editDialog.initialForm.bookingMode = form.bookingMode
    },
    remove() {
      const self = this
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const seqs = rows.map(row => row.seq)
        this.rowData = this.rowData.filter(p => !seqs.includes(p.seq))
        for (const item of rows) {
          if (item.uuid) {
            this.deletedBookingAgentCarrierKeys.push(item.uuid)
          }
        }
      }).catch(() => {
      })
    },
    /**
     * 是否已经存在
     */
    async checkedBookingAgent() {
      const bookingAgentList = this.rowData
      if (bookingAgentList) {
        for (const bookingAgent of bookingAgentList) {
          if (this.editDialog.form.bookingAgentUuid === bookingAgent.bookingAgentUuid) {
            return false
          }
        }
      }
      return true
    },
    carrierTypeChangeHandler() {
      // 切换类型时，将原承运人类型的carrierUuid暂存，切换回去时，还原回去
      const temp = this.editDialog.form.bookingAgentUuid
      this.editDialog.form.bookingAgentUuid = this.tempCarrierUuid
      this.tempCarrierUuid = temp
    }
  }
}
</script>

<style>
</style>
